__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "aohs";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/common/http", "17.3.12", () => (__webpack_require__.e(443).then(() => (() => (__webpack_require__(6443))))));
			register("@angular/common", "17.3.12", () => (__webpack_require__.e(935).then(() => (() => (__webpack_require__(316))))));
			register("@angular/core", "17.3.12", () => (__webpack_require__.e(559).then(() => (() => (__webpack_require__(8559))))));
			register("@angular/router", "17.3.12", () => (__webpack_require__.e(72).then(() => (() => (__webpack_require__(5072))))));
			register("@itero/assets-bff-sdk", "1.0.0-dev.185.51", () => (__webpack_require__.e(602).then(() => (() => (__webpack_require__(4602))))));
			register("@itero/auth-angular", "17.0.14", () => (__webpack_require__.e(195).then(() => (() => (__webpack_require__(6576))))));
			register("rxjs", "7.8.1", () => (__webpack_require__.e(962).then(() => (() => (__webpack_require__(3962))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};